"use client";

import { AlertCircle } from "lucide-react";
import { cn } from "@/lib/utils";

interface AuthErrorProps {
    message: string | null;
    className?: string;
}

export const AuthError = ({ message, className }: AuthErrorProps) => {
    if (!message) return null;

    return (
        <div
            className={cn(
                "flex items-center gap-3 p-4 rounded-xl bg-red-50 border border-red-100 text-red-600 animate-in fade-in slide-in-from-top-2 duration-300",
                className
            )}
        >
            <div className="shrink-0">
                <AlertCircle size={20} className="text-red-500" />
            </div>
            <p className="text-sm font-medium leading-relaxed">
                {message}
            </p>
        </div>
    );
};
